import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_TOLLS](state, data) {
    state.allTolls = data
  },
}
